import { RefObject, useEffect, useState } from 'react';

export const useIframeContentHeight = (ref: RefObject<HTMLIFrameElement>) => {
  const [height, setHeight] = useState<number>();

  useEffect(() => {
    const iframe = ref.current;
    if (!iframe) return;

    let frame = 0;
    let resizeObserver: ResizeObserver | undefined;

    const measure = () => {
      const body = iframe.contentDocument?.body;
      if (!body) return;
      body.style.minHeight = '0';
      const next = body.scrollHeight;
      if (next > 0) setHeight((current) => (current === next ? current : next));
    };

    const scheduleMeasure = () => {
      cancelAnimationFrame(frame);
      frame = requestAnimationFrame(measure);
    };

    const observeDocument = () => {
      const doc = iframe.contentDocument;
      if (!doc?.body) return;
      resizeObserver?.disconnect();
      resizeObserver = new ResizeObserver(scheduleMeasure);
      resizeObserver.observe(doc.body);
      doc.fonts?.ready.then(measure).catch(() => undefined);
      measure();
    };

    iframe.addEventListener('load', observeDocument);
    window.addEventListener('resize', scheduleMeasure);

    observeDocument();

    return () => {
      cancelAnimationFrame(frame);
      iframe.removeEventListener('load', observeDocument);
      window.removeEventListener('resize', scheduleMeasure);
      resizeObserver?.disconnect();
    };
  }, [ref]);

  return height;
};
